<div class="header-fixed menubar-pin parent-container">
    <div id="base">
        <div class="super-container">
            <div class="page-loader-container" *ngIf="isPageLoading">
                <app-new-loader></app-new-loader>
            </div>
            <section *ngIf="!isPageLoading">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="text-primary page-heading">
                            {{'academicHolidaysHeading' | translate}}
                        </h2>
                    </div>

                </div>
                <div class="section-body">
                    <div class="content-container">
                        <div class="tab-pane active">
                            <div class="header-button-container">
                                <button (click)="openCreateHolidayForm()">
                                    <span>
                                        <img src="../../assets/img/Add.png" alt="add">
                                        {{'addHolidayBtnText' | translate}}
                                    </span>
                                </button>
                            </div>
                            <div class="data-list-container">
                                <div *ngIf="academicHolidaysList && (academicHolidaysList).length > 0; else noData">
                                    <div class="data-list" *ngFor="let data of academicHolidaysList; let i = index">
                                        <div class="data-list-content">
                                            {{ data.holidayTitle }}
                                        </div>
                                        <div class="list-button">
                                            <button class="list-btn-edit" (click)="openEditHolidayForm(data)">
                                                <img src="../../assets/img/edit.png" alt="edit">
                                            </button>
                                            <button class="list-btn-delete" (click)="openDeleteHolidayForm(data)">
                                                <img src="../../assets/img/delete.png" alt="delete">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #noData>
                                    <div class="data-list">
                                        <div class="data-list-content text-center">
                                            {{'noHolidaysAvailable' | translate}}
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div class="overlay" tabindex="-1" role="dialog" *ngIf="showOverlay">
    <div class="modal-dialog popup" role="document" *ngIf="isCreatePopupVisible || isEditPopupVisible">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="isEditPopupVisible; else createText">
                    {{'editHolidayPopupHeadingText' | translate}}
                </h5>
                <ng-template #createText>
                    <h5 class="modal-title">
                        {{'popupAddHolidayHeadingText' | translate}}
                    </h5>
                </ng-template>
            </div>
            <form [formGroup]="academicHolidayForm" (ngSubmit)="onFormSubmit()">
                <div class="popup-body modal-body">
                    <div class="form-group">
                        <label for="academicHolidayName">{{'academicHolidayName' | translate}}
                            <span class="required-param">
                                {{'requiredParam' | translate}}
                            </span>
                        </label>
                        <input type="text" id="academicHolidayName" formControlName="academicHolidayName"
                            placeholder="{{'academicHolidayNamePlaceholder' | translate}}">
                        <div class="error-block">
                            <div *ngIf="academicHolidayForm.get('academicHolidayName')?.touched">
                                <small
                                    *ngIf="academicHolidayForm.get('academicHolidayName')?.hasError('required') || academicHolidayForm.get('academicHolidayName')?.hasError('minlength')">
                                    {{'requiredacademicHolidayName' | translate}}
                                </small>
                                <small *ngIf="!academicHolidayForm.get('academicHolidayName')?.hasError('required') && !academicHolidayForm.get('academicHolidayName')?.hasError('minlength')
                                    && academicHolidayForm.get('academicHolidayName')?.hasError('maxlength')
                                    ">
                                    {{'maxAcademicHolidayName' | translate}}
                                </small>
                                <small *ngIf="
                                       !academicHolidayForm.get('academicHolidayName')?.hasError('required') 
                                    && !academicHolidayForm.get('academicHolidayName')?.hasError('minlength')
                                    && !academicHolidayForm.get('academicHolidayName')?.hasError('maxlength') 
                                    && academicHolidayForm.get('academicHolidayName')?.hasError('invalidCharacter')">
                                    {{'invalidHolidayName' | translate}}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="holidayDescription">
                            {{'holdiayDescription' | translate}}
                        </label>
                        <textarea name="holidayDescription" id="holidayDescription"
                            formControlName="academicHolidayDescription" class="description-field" rows="3">
                        </textarea>
                        <div class="error-block">
                            <div *ngIf="academicHolidayForm.get('academicHolidayDescription').errors && 
                                        (academicHolidayForm.get('academicHolidayDescription').dirty || 
                                         academicHolidayForm.get('academicHolidayDescription').touched)">
                                <small class="text-danger"
                                    *ngIf="academicHolidayForm.get('academicHolidayDescription').errors?.['minlength']">
                                    {{'minDescriptionLimit' | translate}}
                                </small>
                                <small class="text-danger"
                                    *ngIf="academicHolidayForm.get('academicHolidayDescription').errors?.['maxlength']">
                                    {{'maxDescriptionLimit' | translate}}
                                </small>
                                <small class="text-danger"
                                    *ngIf="
                                    !academicHolidayForm.get('academicHolidayDescription').errors?.['maxlength'] &&
                                    !academicHolidayForm.get('academicHolidayDescription').errors?.['minlength'] &&
                                    academicHolidayForm.get('academicHolidayDescription').errors?.['invalidCharacter']">
                                    {{'invalidDescription' | translate}}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="dates-container">
                        <div class="form-group">
                            <label for="startDate">{{'startDate' | translate}}
                                <span class="required-param">
                                    {{'requiredParam' | translate}}
                                </span>
                            </label>
                            <input type="date" id="startDate" formControlName="startDate" [min]="academicStartDate"
                                [max]="academicEndDate" (change)="validateDates()">
                            <div class="error-block">
                                <div *ngIf="academicHolidayForm.get('startDate')?.touched">
                                    <small
                                        *ngIf="academicHolidayForm.controls['startDate'].hasError('invalidStartDate')">
                                        {{'startDateValidationMessage' | translate}} {{ academicStartDate }}
                                    </small>
                                    <small *ngIf="
                                    !academicHolidayForm.controls['startDate'].hasError('invalidStartDate') &&
                                    academicHolidayForm.controls['startDate'].hasError('startDateMorethenEndDate')">
                                        {{'dateValidation' | translate}}
                                    </small>
                                </div>
                                <div *ngIf="academicHolidayForm.get('startDate')?.untouched">
                                    <small
                                        *ngIf="academicHolidayForm.controls['startDate'].hasError('startDateMorethenEndDate')">
                                        {{'dateValidation' | translate}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="endDate">{{'endDate' | translate}}
                                <span class="required-param">
                                    {{'requiredParam' | translate}}
                                </span>
                            </label>
                            <input type="date" id="endDate" formControlName="endDate" [min]="academicStartDate"
                                [max]="academicEndDate" (change)="validateDates()">
                            <div class="error-block">
                                <div *ngIf="academicHolidayForm.get('endDate')?.touched">
                                    <small *ngIf="academicHolidayForm.get('endDate')?.hasError('invalidEndDate')">
                                        {{'endDateValidationMessage' | translate}} {{ academicEndDate }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{'selectClasses' | translate}}
                            <span class="required-param">
                                {{'requiredParam' | translate}}
                            </span>
                        </label>
                        <div class="dropdown-container">
                            <div class="form-group">
                                <ng-select [items]="classDropdownDataArray" bindLabel="displayName"
                                    groupBy="classCategoryName" [multiple]="true" [closeOnSelect]="false"
                                    [selectableGroup]="true" [selectableGroupAsModel]="false"
                                    formControlName="selectedClasses" (change)="onSelectionChange($event)"
                                    placeholder="{{'pleaseSelectClassesPlaceholder' | translate}}">
                                    <ng-template ng-header-tmp>
                                        <button type="button" (click)="selectAllClasses()"
                                            class="select-all-btn-dropdown">{{ 'selectAll' | translate }}</button>
                                    </ng-template>
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        <span>{{ item.classCategoryName }}</span>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        <strong *ngIf="item.items">{{ item.name }}</strong>
                                        <span *ngIf="!item.items">{{ item.displayName }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="closed-btn btn btn-raised ink-reaction btn-info" (click)="closePopup()"
                        aria-label="Close" [disabled]="academicHolidayFormSubmit">{{'closeText' | translate}}</button>
                    <button type="submit" class="submit-btn btn btn-raised ink-reaction btn-info"
                        [disabled]="academicHolidayForm.invalid || academicHolidayFormSubmit || academicHolidayForm.pristine">
                        <div *ngIf="academicHolidayFormSubmit;else submitText">
                            <app-button-loader></app-button-loader>
                        </div>
                        <ng-template #submitText>
                            {{
                            isEditPopupVisible ? ('editText' | translate) : ('createText' | translate)
                            }}
                        </ng-template>
                    </button>
                </div>
            </form>

        </div>
    </div>

    <div class="modal-dialog popup" role="document" *ngIf="isDeletePopupVisible">
        <div class="modal-content">
            <div class="modal-header">
                <h5>{{'deleteHolidayHeadingModal' | translate}}</h5>
            </div>
            <div class="popup-body modal-body text-center">
                <h4>
                    {{'deleteParagraph' | translate}}
                </h4>
            </div>
            <div class="modal-footer">
                <button type="button" class="closed-btn btn btn-raised ink-reaction btn-info" (click)="closePopup()"
                    [disabled]="academicHolidayFormSubmit" aria-label="Close">
                    {{'closeText' | translate}}
                </button>
                <button type="submit" class="submit-btn btn btn-raised ink-reaction btn-danger"
                    (click)="deleteAcademicHoliday()" [disabled]="academicHolidayFormSubmit">
                    <div *ngIf="academicHolidayFormSubmit;else submitText">
                        <app-button-loader></app-button-loader>
                    </div>
                    <ng-template #submitText>
                        {{ 'deleteText' | translate }}
                    </ng-template>
                </button>
            </div>
        </div>
    </div>